import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MAIN_PAGE } from './constants/routing.constants';
import { RoutesDictionary } from './dictionaries/routes.dictionary';
import { JobStatus } from './enums/job-status.enum';
import { PlacementStatus } from './enums/placement-status.enum';
import { SectionsEnum } from './enums/sections.enum';
import { SortDirectionEnum } from './enums/sort-direction.enum';
import { JobsPlacementsComponent } from './jobs-placements.component';

const routes: Routes = [
    {
        path: '',
        component: JobsPlacementsComponent,
        children: [
            {
                path: '',
                redirectTo: MAIN_PAGE,
                pathMatch: 'full',
            },
            {
                path: RoutesDictionary.OPPORTUNITIES,
                // canActivate: [AuthGuard],
                loadChildren: (): Promise<unknown> =>
                    import('./pages/jobs/jobs.module').then((m) => m.JobsPageModule),
                data: {
                    statuses: [JobStatus.OPEN_OPPORTUNITY],
                    titleKey: SectionsEnum.OPPORTUNITIES,
                    sortDirection: SortDirectionEnum.ASC,
                },
                // resolve: { message: JobsLoaderResolver }
            },
            {
                path: RoutesDictionary.APPLICATIONS,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/jobs/jobs.module').then((m) => m.JobsPageModule),
                data: {
                    statuses: [JobStatus.CURRENT_APPLICATION, JobStatus.INTERESTED_SOME_SHIFTS],
                    titleKey: SectionsEnum.APPLICATIONS,
                    sortDirection: SortDirectionEnum.ASC,
                },
            },
            {
                path: RoutesDictionary.ASSIGNMENTS,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/placements/placements.module').then(
                        (m) => m.PlacementsPageModule,
                    ),
                data: {
                    statuses: [PlacementStatus.PLACEMENT_CURRENT],
                    titleKey: SectionsEnum.ASSIGNMENTS,
                    sortDirection: SortDirectionEnum.ASC,
                },
            },
            {
                path: RoutesDictionary.FINISHED_ASSIGNMENTS,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/placements/placements.module').then(
                        (m) => m.PlacementsPageModule,
                    ),
                data: {
                    statuses: [PlacementStatus.PLACEMENT_FINISHED],
                    titleKey: SectionsEnum.FINISHED_ASSIGNMENTS,
                    sortDirection: SortDirectionEnum.DESC,
                },
            },
            {
                path: RoutesDictionary.UNANSWERED_OPPORTUNITIES,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/jobs/jobs.module').then((m) => m.JobsPageModule),
                data: {
                    statuses: [JobStatus.IGNORED_OPPORTUNITY],
                    titleKey: SectionsEnum.UNANSWERED_OPPORTUNITIES,
                    sortDirection: SortDirectionEnum.DESC,
                },
            },
            {
                path: RoutesDictionary.DECLINED_OPPORTUNITIES,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/jobs/jobs.module').then((m) => m.JobsPageModule),
                data: {
                    statuses: [JobStatus.DECLINED_OPPORTUNITY],
                    titleKey: SectionsEnum.DECLINED_OPPORTUNITIES,
                    sortDirection: SortDirectionEnum.DESC,
                },
            },
            {
                path: RoutesDictionary.SUCCESSFUL_APPLICATIONS,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/jobs/jobs.module').then((m) => m.JobsPageModule),
                data: {
                    statuses: [JobStatus.SUCCESSFUL_APPLICATION],
                    titleKey: SectionsEnum.SUCCESSFUL_APPLICATIONS,
                    sortDirection: SortDirectionEnum.DESC,
                },
            },
            {
                path: RoutesDictionary.UNSUCCESSFUL_APPLICATIONS,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/jobs/jobs.module').then((m) => m.JobsPageModule),
                data: {
                    statuses: [JobStatus.UNSUCCESSFUL_APPLICATION],
                    titleKey: SectionsEnum.UNSUCCESSFUL_APPLICATIONS,
                    sortDirection: SortDirectionEnum.DESC,
                },
            },
            {
                path: RoutesDictionary.UNANSWERED_APPLICATIONS,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/jobs/jobs.module').then((m) => m.JobsPageModule),
                data: {
                    statuses: [JobStatus.UNANSWERED_APPLICATION],
                    titleKey: SectionsEnum.UNANSWERED_APPLICATIONS,
                    sortDirection: SortDirectionEnum.DESC,
                },
            },
            {
                path: RoutesDictionary.COLLECTION,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/collection/collection.module').then((m) => m.CollectionPageModule),
            },
            {
                path: RoutesDictionary.JOB,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/job/job.module').then((m) => m.JobPageModule),
            },
            {
                path: RoutesDictionary.SHIFT,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/shift/shift.module').then((m) => m.ShiftPageModule),
            },
            {
                path: RoutesDictionary.PLACEMENT,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/placement/placement.module').then((m) => m.PlacementPageModule,
                    ),
            },
            {
                path: RoutesDictionary.RECORD_TIME,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/record-time/record-time.module').then((m) => m.RecordTimePageModule,
                    ),
            },
            {
                path: RoutesDictionary.RECORD_TIME_DAILY,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/record-time-daily/record-time-daily.module').then((m) => m.RecordTimeDailyPageModule),
            },
            {
                path: RoutesDictionary.RECORD_TIME_ENTITY,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/record-time-entity/record-time-entity.module').then((m) => m.RecordTimeEntityPageModule),
            },
            {
                path: RoutesDictionary.RECORD_EXPENSE,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/record-expense/record-expense.module').then((m) => m.RecordExpensePageModule),
            },
            {
                path: RoutesDictionary.TIMESHEET_VIEW_TIMESHEET,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/view-timesheet/view-timesheet.module').then((m) => m.ViewTimesheetPageModule),
            },
            {
                path: RoutesDictionary.SHIFT_CONFIRMATIONS,
                loadChildren: (): Promise<unknown> =>
                    import('./pages/shift-confirmations/shift-confirmations.module').then((m) => m.ShiftConfirmationsModule),
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class JobsPlacementsRoutingModule { }
